import React, { createContext } from 'react';

const DevicePlatformContext = createContext<null | string>(null);

const DevicePlatformProvider: React.FC<React.PropsWithChildren<{
  platform: string;
}>> = ({ platform, children }) => {
  return (
    <DevicePlatformContext.Provider value={platform}>
      {children}
    </DevicePlatformContext.Provider>
  );
};

export default DevicePlatformContext;
export { DevicePlatformProvider };
